import { createLogic } from 'redux-logic'
import handleErrors from '@app/helpers/handleErrors'
import { SYNC_MEZZO_TIME } from '@app/constants/mezzoTime/mezzoTime'
import { setMezzoTime } from '@app/actions/mezzoTime/mezzoTime'
import Api from '@app/api/mezzoTime/fetchMezzoTime'
import { API_REQUEST_CANCEL } from '@app/constants/apiRequest'
import { apiRequestSent, apiRequestDone, apiRequestFailed } from '@app/actions/apiRequest'

const fetchMezzoTimeLogic = createLogic({
  type: SYNC_MEZZO_TIME,
  cancelType: API_REQUEST_CANCEL,

  transform({ getState, action }, next) {
    const { secrets: { accessToken: { token: accessToken } } } = getState()
    next({
      ...action,
      accessToken,
    })
  },

  process({ action }, dispatch, done) {
    dispatch(apiRequestSent(SYNC_MEZZO_TIME))
    Api.fetchMezzoTime(action.accessToken)
      .then((response) => {
        const { data } = response
        dispatch(setMezzoTime(data))
        dispatch(apiRequestDone(SYNC_MEZZO_TIME))
      })
      .catch((error) => {
        if (error) {
          const currentError = handleErrors(error)
          dispatch(apiRequestFailed(currentError))
        } else {
          throw new Error('fetchMezzoTime failed without error')
        }
      })
      .then(() => done())
  },
})

export default fetchMezzoTimeLogic
